import type { InputHTMLAttributes } from "react";
import s from "./primitives.module.css";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

/** A plain input. It owns NO validation: the amount field's rules (accept `[0-9.]`, reject a second `.` rather
 *  than silently truncating, string space only) belong to `features/trade/AmountField.tsx`, because they are
 *  money rules and money rules live where they can be unit-tested with the converter beside them. */
export function Input({ invalid, className, ...rest }: InputProps) {
  const classes = [s.input, invalid ? s.inputInvalid : null, className].filter(Boolean).join(" ");
  return <input className={classes} aria-invalid={invalid || undefined} {...rest} />;
}
